module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-section"
  }, [(_vm.jump.options_ids.length === 0) ? _c('div', [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_the_answers')))]), _vm._v(" "), _c('select', {
    staticClass: "klickart-select",
    on: {
      "change": function($event) {
        return _vm.jumpUpdateOptionId({
          jump: _vm.jump,
          index: 0,
          event: $event
        })
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.label))])
  })], 2), _vm._v(" "), _c('add-option-button', {
    attrs: {
      "jump": _vm.jump,
      "show": true
    }
  })], 1) : _c('div', [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_the_answers')))]), _vm._v(" "), _vm._l((_vm.jump.options_ids), function(optionId, index) {
    return _c('div', [_c('div', {
      staticClass: "klickart-select-inline"
    }, [_c('select', {
      staticClass: "klickart-select",
      on: {
        "change": function($event) {
          return _vm.jumpUpdateOptionId({
            jump: _vm.jump,
            index: index,
            event: $event
          })
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option) {
      return _c('option', {
        domProps: {
          "value": option.id,
          "selected": option.id === optionId
        }
      }, [_vm._v(_vm._s(option.label))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "nav-button-inline"
    }, [_c('remove-option-button', {
      attrs: {
        "jump": _vm.jump,
        "index": index,
        "show": _vm.jump.options_ids.length > 1
      }
    })], 1)]), _vm._v(" "), _c('add-option-button', {
      attrs: {
        "jump": _vm.jump,
        "show": index === _vm.jump.options_ids.length - 1
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2c5505ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/selects/MultipleAnswer.vue
 ** module id = 788
 ** module chunks = 1
 **/